const TOGGLE_WORKER_URL = "https://bitter-dream-164f.minartscreations.workers.dev/";

document.addEventListener("DOMContentLoaded", async () => {

  const container = document.getElementById("commission-toggle");

  if (!container) return;

  try {

    const response = await fetch(TOGGLE_WORKER_URL);

    if (!response.ok) {
      throw new Error("Unable to load studio status.");
    }

    const data = await response.json();

    const isOpen = data.commissionStatus === "Open";

    container.innerHTML = `
  <div class="commission-toggle ${isOpen ? "" : "closed"}">

    <div class="commission-toggle__thumb">
      ${isOpen ? "🎨" : "🧳"}
    </div>

  </div>
`;

const toggle = container.querySelector(".commission-toggle");

const tooltip = document.getElementById("commission-tooltip");

let timer;

toggle.addEventListener("click", () => {

  tooltip.textContent = isOpen
    ? "🎨 Open for Commissions"
    : "🧳 Studio Break";

  tooltip.classList.add("show");

  clearTimeout(timer);

  timer = setTimeout(() => {

    tooltip.classList.remove("show");

  }, 2000);

});

  } catch (error) {

    console.error(error);

  }

});

